import { render, staticRenderFns } from "./Furniture.vue?vue&type=template&id=12759334&"
import script from "./Furniture.vue?vue&type=script&lang=js&"
export * from "./Furniture.vue?vue&type=script&lang=js&"
import style0 from "./Furniture.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports